import {captureException} from '@sentry/browser'

export const fetch: typeof window.fetch = (input, init) => {
  const body =
    init && init.body
      ? init.body.constructor === FormData
        ? Array.from((init.body as FormData).entries()).reduce(
            (acc, [key, value]) => ({...acc, [key]: value}),
            {},
          )
        : init.body
      : {}
  return new Promise<Response>((resolve, reject) => {
    window
      .fetch(input, init)
      .then((response: Response) => {
        if (response.status >= 500) {
          captureException(
            Error(`Request to endpoint ${input} received status ${response.status}`),
            {
              extra: {
                ...init,
                ...(body ? {body} : {}),
              },
            },
          )
        }
        resolve(response)
      })
      .catch((error) => {
        // The caller aborted on purpose, e.g. react-query cancelling the query of an unmounted component
        if (error?.name !== 'AbortError') {
          captureException(error, {
            extra: {
              ...init,
              ...(body ? {body} : {}),
            },
          })
        }
        reject(error)
      })
  })
}
